import React from 'react';

type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
};

const GiftIcon = (props: Props) => {
  const {
    width = '18',
    height = '18',
    fillColor = 'none',
    strokeColor = 'black',
    strokeWidth = 1.5,
  } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      {/* Box body + lid carry the fill; the center line is stroke-only so it
       * reads as a ribbon divider rather than a filled region. */}
      <path
        d="M2 7h20v5H2z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 12v10H4V12"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22V7"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GiftIcon;
